import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {MvsWidgetConfigFormFieldUi} from '../mvs-widget-configuration/data/mvs-widget-config-form-field.ui';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {UiWidgetFormFields} from './data/ui-widget-form-fields';
import {StylingOptions} from '../mvs-widget-configuration/styling-classes/styling-options';
import {MvsFormFieldService} from '../../../../form/field/service/mvs-form-field.service';
import {MenuItem} from 'primeng/api';
import {Subscription} from 'rxjs';
import {WidgetConfigService} from '../../../service/widget-config.service';
import {
    InputOutputConfigurationOptionsDropdownInterface
} from '../mvs-widget-configuration/input-output-configuration-options.dropdown.interface';
import {MvsFormDto} from '../../../../dto/form/dto/mvs-form.dto';
import {WidgetData} from '../../../widget-data';
import {MvsFormFieldDto} from '../../../../dto/form/dto/mvs-form-field.dto';
import {MvsCoreService} from '../../../../service/mvs-core.service';
import {WidgetConfigFormField} from '../../../widget-config-form-field';
import {MvsFormValueListDto} from '../../../../dto/form/dto/mvs-form-value-list.dto';
import {MvsFormValueListEntryDto} from '../../../../dto/form/dto/mvs-form-value-list-entry.dto';
import {FormFieldSpecialType} from '../../../form-field-special-type.enum';

@Component({
    selector: 'mvs-widget-config-fields',
    templateUrl: './mvs-widget-config-fields.component.html',
    styleUrls: ['./mvs-widget-config-fields.component.scss'],
    standalone: false
})
export class MvsWidgetConfigFieldsComponent implements OnInit, OnChanges, OnDestroy {

    @Input() widgetFields: MvsWidgetConfigFormFieldUi[];
    @Input() widgetType: string;
    @Input() widgetData: WidgetData;
    @Input() form: MvsFormDto;

    @Input() modeHideFields: boolean;
    @Output() modeHideFieldsChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output() onWidgetFields: EventEmitter<MvsWidgetConfigFormFieldUi[]> = new EventEmitter<MvsWidgetConfigFormFieldUi[]>();

    formFields: MvsFormFieldDto[];
    optionsOutputFormFields: InputOutputConfigurationOptionsDropdownInterface[];
    optionsInputFormFields: InputOutputConfigurationOptionsDropdownInterface[];
    optionsStylingClasses: InputOutputConfigurationOptionsDropdownInterface[];
    formGroup: FormGroup;
    rowExtensionOpen: Record<string, boolean> = {};
    contextMenuSelectedRow: FormGroup;
    fieldsContextMenuItems: MenuItem[];
    selectAllContextMenu: MenuItem[];
    fieldNameContextMenu: MenuItem[];

    fieldNameRegularView: boolean = true;
    formGroupSubscription: Subscription;
    showFilterInput: boolean = false
    visibleFields = {};

    fontSizeEntries = [
        {label: 'x', image: ''},
        {label: 'Small', image: 'text-sm'},
        {label: 'Medium', image: 'text-lg'},
        {label: 'Large', image: 'text-2xl'}
    ];
    showAllFields: boolean //this will be used to toggle view of either visible fields or all fields
    widgetUiFields: any;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    showReorderFields: boolean;
    showNullFields: boolean;

    fieldNameOptions = [];
    sourceOptions = [];
    labelOptions = [];
    outputFieldOptions = [];

    // Controls ALL rows internally
    widgetUiFieldsAll: any;
    pageSize = 100;
    currentLimit = 100;
     batching = false;
     fieldsLoadingBusy = false;
    showAuditFields = false;
    showForeignIdFields = false;
    constructor(protected formBuilder: FormBuilder,
                protected formFieldService: MvsFormFieldService,
                protected widgetConfigService: WidgetConfigService,
                protected coreService: MvsCoreService) {
    }

    ngOnInit(): void {

        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {

        this.optionsOutputFormFields = this.formFieldService.getOutputFieldsAsList(true);
        this.optionsInputFormFields = this.formFieldService.getInputFieldsAsList(true);
        this.optionsStylingClasses = StylingOptions.options;

        this.sort(this.optionsOutputFormFields);
        this.sort(this.optionsStylingClasses);
        this.sort(this.optionsInputFormFields);

        this.fieldsContextMenuItems = [
            {label: 'nach ganz oben', command: () => this.movePositionField(this.contextMenuSelectedRow, 'top')},
            {label: 'nach ganz unten', command: () => this.movePositionField(this.contextMenuSelectedRow, 'bottom')}
        ];

        this.selectAllContextMenu = [
            {label: 'alle selektieren', command: () => this.selectAllFields(true)},
            {label: 'alle deselektieren', command: () => this.selectAllFields(false)}
        ];

        this.fieldNameContextMenu = [
            {label: 'Show Regular Names', command: () => this.fieldNameRegularView = true},
            {label: 'Show Technical Names', command: () => this.fieldNameRegularView = false}
        ];
        this.showAllFields = true;
        this.showReorderFields = true;
        this.showNullFields = true;

        this.handleFieldConfiguration();
        this.refreshComponent();
        this.generateAllOptions();
    }

    filters = {
        fieldName: null,
        source: null,
        label: null,
        outputField: null
    };

    typedFilter: string = '';
    typedFilterColumn: string | null = null;

    onFieldFilter(event: any, type: string) {
        this.typedFilter = (event?.filter || '').toLowerCase();
        this.typedFilterColumn = type;   // remember which column is filtering
        if(this.typedFilter.length >= 2){
            this.applyFilters(true);
        }
    }

    getFieldContextMenu(row: any, index: number): any[] {
        const lastIndex = this.widgetUiFields.length - 1;

        const items = [];

        if (index !== 0) {
            items.push({
                label: 'nach ganz oben',
                command: () => this.movePositionField(row, 'top')
            });
        }

        if (index !== lastIndex) {
            items.push({
                label: 'nach ganz unten',
                command: () => this.movePositionField(row, 'bottom')
            });
        }

        return items;
    }

    applyFilters(isPartialSearch?: boolean) {
        const {fieldName, source, label, outputField} = this.filters;
        this.widgetUiFields = this.widgetField.controls.filter(field => {

            const fField = field.get('uiFieldLabel')?.value?.trim()?.toLowerCase() || '';
            const fSource = field.get('uiFieldReference')?.value?.trim()?.toLowerCase() || '';
            const fLabel = field.get('uiLabel')?.value?.trim()?.toLowerCase() || '';
            const fOutput = field.get('uiOutputField')?.value;

            // === Select-based (Exact match) ===
            if (fieldName && fField !== fieldName.toLowerCase()) return false;
            if (source && fSource !== source.toLowerCase()) return false;
            if (label && fLabel !== label.toLowerCase()) return false;

            if (outputField) {
                if (outputField === 'default') {
                    if (fOutput !== null) return false;
                } else {
                    if (fOutput?.trim?.() !== outputField) return false;
                }
            }

            // === ONE partial search only ===
            if (isPartialSearch && this.typedFilter) {

                switch (this.typedFilterColumn) {
                    case 'fieldName':
                        if (!fField.includes(this.typedFilter)) return false;
                        break;

                    case 'source':
                        if (!fSource.includes(this.typedFilter)) return false;
                        break;

                    case 'label':
                        if (!fLabel.includes(this.typedFilter)) return false;
                        break;

                    case 'outputField':
                        const out = fOutput?.trim?.().toLowerCase() || '';

                        // --- CASE 1: user typed 'def' => ONLY default must match ---
                        if (this.typedFilter.startsWith('de')) {
                            return fOutput === null;
                        }

                        // --- CASE 2: user typed 'd' => default + all starting with 'd' ---
                        if (this.typedFilter === 'd') {
                            if (fOutput === null) return true;           // default matches
                            if (out.startsWith('d')) return true;        // values starting with 'd' match
                            return false;
                        }

                        // --- CASE 3: normal partial search (non-default should match) ---
                        if (!out.includes(this.typedFilter)) return false;
                        break;
                }
            }

            return true;
        });

        // Reset visible list using incremental rendering
        this.widgetUiFieldsAll = this.widgetUiFields;
        this.widgetUiFields = this.widgetUiFieldsAll.slice(0, this.currentLimit);
    }

    generateAllOptions() {
        const unique = (arr) =>
            Object.values(arr.reduce((acc, curr) => {
                acc[curr.value] = curr;
                return acc;
            }, {}));

        this.fieldNameOptions = unique(
            this.widgetUiFields
                .map(f => ({
                    label: f.get('uiFieldLabel')?.value?.trim() || f.get('field')?.value?.trim(),
                    value: f.get('uiFieldLabel')?.value?.trim()
                }))
                .filter(x => x.label)
        );

        this.sourceOptions = unique(
            this.widgetUiFields
                .map(f => ({
                    label: f.get('uiFieldReference')?.value?.trim(),
                    value: f.get('uiFieldReference')?.value?.trim()
                }))
                .filter(x => x.label)
        );

        this.labelOptions = unique(
            this.widgetUiFields
                .map(f => ({
                    label: f.get('uiLabel')?.value?.trim(),
                    value: f.get('uiLabel')?.value?.trim()
                }))
                .filter(x => x.label)
        );

        // Collect ONLY uiOutputField values present in widget rows
        const presentOutputFields = this.widgetUiFields
            .map(f => f.get('uiOutputField')?.value)
            .filter(v => v !== undefined); // keep null (default) too

        // Convert to normalized unique values
        const uniqueOutputValues = [...new Set(presentOutputFields)];

        // Build dropdown options based on ONLY these values
        this.outputFieldOptions = uniqueOutputValues.map(v => {
            if (v === null) {
                return {label: 'default', value: 'default'};
            }

            const match = this.optionsOutputFormFields.find(o => o.id === v);
            return {
                label: match?.label?.trim() || v,
                value: v
            };
        });
    }

    selectAllFields(activate: boolean) {

        this.widgetField.controls.forEach((widgetFieldGroup: FormGroup) => {

            const uiHiddenControl = widgetFieldGroup.get('uiHidden');
            if ((!this.modeHideFields && activate == !this.modeHideFields) ||
                (this.modeHideFields && activate == this.modeHideFields)) {
                uiHiddenControl.setValue(true);
            } else {
                uiHiddenControl.setValue(false);
            }

        });
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initializeForm();
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes['widgetFields']) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
        if (this.formGroupSubscription) {
            this.formGroupSubscription.unsubscribe();
        }
    }

    initializeForm() {
        this.formGroup = this.formBuilder.group({
            widgetField: this.formBuilder.array([]),
        });

        this.populateData();

        this.updateFormFields();

        // this.widgetUiFields = this.widgetField.controls;

        this.widgetUiFieldsAll = this.widgetField.controls;
        this.currentLimit = 100;
        this.widgetUiFields = this.widgetUiFieldsAll.slice(0, this.currentLimit);
        this.filterBySpecialType();
        this.formGroupSubscription = this.formGroup.valueChanges.subscribe(value => {
            const sortedFields = [...value.widgetField].sort((a, b) => (a.uiPriority ?? 0) - (b.uiPriority ?? 0));
            this.onWidgetFields.emit(sortedFields);
        });
    }

    // Helper to compare previous and current values
    findChanges(previous, current) {
        const changes = [];
        Object.keys(current.widgetField).forEach((key) => {
            if (current.widgetField[key] !== previous.widgetField[key]) {
                changes.push({field: key, value: current.widgetField[key]});
            }
        });
        return changes;
    }

    protected updateFormFields() {

        if (this.widgetType == 'object') {

            this.busy = true;

            //TODO: need to fix so that if we select a default value such as a group so that we get types related to that group

            // derive all the defaults which were already set
            // const dtoTemplate = new DtoTemplate();
            // const dto: DtoDetail = new DtoDetail({});
            //
            // const widgetFormControlArray = this.formGroup.get('widgetField') as FormArray;
            //
            // for (let widgetFormControl of widgetFormControlArray.controls) {
            //
            //   if (widgetFormControl['controls']) {
            //
            //     if (widgetFormControl.get('defaultValue')) {
            //
            //       if (widgetFormControl.get('defaultValue').value !== undefined && widgetFormControl.get('defaultValue').value !== '') {
            //         let formFieldName = widgetFormControl.value.formField.id;
            //
            //         if (formFieldName.endsWith('DtoName')) {
            //           formFieldName = formFieldName.replace('DtoName', 'DtoId');
            //         }
            //
            //         dto[formFieldName] = widgetFormControl.get('defaultValue').value;
            //       }
            //
            //     }
            //
            //   }
            // }
            //
            // dtoTemplate.dto = dto;

            // this.coreService.getCrudService(this.widgetData.dataProviderObject).template(dtoTemplate).subscribe(value => {
            //   const formFields = [];
            //
            //   const widgetFormFields: WidgetConfigFormField[] = this.formGroup.get('widgetField').value;
            //
            //   for (let widgetFormField of widgetFormFields) {
            //
            //     let formFieldName = widgetFormField.field;
            //
            //     if (formFieldName.endsWith('DtoName')) {
            //       formFieldName = formFieldName.replace('DtoName', 'DtoId');
            //     }
            //
            //     if (value.formFields[formFieldName]) {
            //       formFields.push(value.formFields[formFieldName]);
            //     } else {
            //       formFields.push({});
            //     }
            //   }
            //   this.formFields = formFields;
            //
            //   this.initialized = true;
            //   this.busy = false;
            //
            // }, error => {
            //   this.busy = false;
            // });

            const formFields = [];

            const widgetFormFields: WidgetConfigFormField[] = this.formGroup.get('widgetField').value;

            for (let widgetFormField of widgetFormFields) {

                let formFieldName = widgetFormField.field;

                if (formFieldName.endsWith('DtoName')) {
                    formFieldName = formFieldName.replace('DtoName', 'DtoId');
                }

                if (this.form.formFields[formFieldName]) {
                    formFields.push(this.form.formFields[formFieldName]);
                } else {
                    formFields.push({});
                }
            }
            this.formFields = formFields;

            this.initialized = true;
            // this.formFields = this.formGroup.value.widgetField.map(item => item.formField);

        } else {
            this.initialized = true;
            this.formFields = this.formGroup.value.widgetField.map(item => item.formField);
        }

    }

    private populateData() {
        const sortedFields = [...this.widgetFields].sort((a, b) => (a.uiPriority ?? 0) - (b.uiPriority ?? 0));
        sortedFields.forEach((field) => {
            const newFormGroup: FormGroup = this.createFormGroup();
            newFormGroup.patchValue(field);

            // get output field id
            const outputFieldId = newFormGroup.get('uiOutputField').value;
            const inputFieldId = newFormGroup.get('uiInputField').value;

            // Add and patch nested controls
            if (field.uiConfigData) {

                if (!newFormGroup.get('uiConfigData')) {
                    newFormGroup.addControl('uiConfigData', new FormGroup({}));
                }

                const uiConfigDataGroup = newFormGroup.get('uiConfigData') as FormGroup;

                Object.keys(field.uiConfigData).forEach((key) => {
                    if (!uiConfigDataGroup.get(key)) {

                        const value = field.uiConfigData[key];

                        uiConfigDataGroup.addControl(key, new FormControl(value));
                    }
                });

            }

            if (outputFieldId) {
                this.onUiOutputFieldChange(newFormGroup, outputFieldId);
            }
            if (inputFieldId) {
                this.onUiInputFieldChange(newFormGroup, inputFieldId);
            }
            this.widgetField.push(newFormGroup);
        });
    }

    private createFormGroup(): FormGroup {
        const formGroupObject = {};
        const field = new UiWidgetFormFields();
        for (const key in field) {

            let currentValue = field[key];

            if (!currentValue) {
                currentValue = '';
            }

            formGroupObject[key] = new FormControl(currentValue)

            if (key == 'uiCssStyle') {
                field.formField.id = key;
                field.formField.uiInputControl = 'multiSelectString';
                field.formField.valueList = MvsFormValueListDto.create(this.optionsStylingClasses);
            }

            formGroupObject[key]['formField'] = field.formField;
        }

        const formGroup = new FormGroup(formGroupObject);

        // Add uiConfigData as a child FormGroup to hold config data
        // formGroup.addControl('uiConfigData', new FormGroup({}));

        // Subscribe to uiOutputField changes
        formGroup.get('uiOutputField').valueChanges.subscribe((fieldId: string) => {
            this.onUiOutputFieldChange(formGroup, fieldId);
        });

        // Subscribe to uiInputField changes
        formGroup.get('uiInputField').valueChanges.subscribe((fieldId: string) => {
            this.onUiInputFieldChange(formGroup, fieldId);
        });

        return formGroup;
    }

    get widgetField(): FormArray {
        return this.formGroup.get('widgetField') as FormArray;
    }

    toggleHideFields() {
        this.modeHideFields = !this.modeHideFields;
        this.toggleHiddenFields();
        this.modeHideFieldsChange.emit(this.modeHideFields);
    }

    toggleAllFieldsVisibility() {
        const currentState = this.widgetField.get('0').get('uiHidden').value;

        this.widgetField.controls.forEach((widgetFieldGroup: FormGroup) => {
            Object.keys(widgetFieldGroup.controls).forEach(controlName => {
                const control = widgetFieldGroup.get('uiHidden');
                if (control) {
                    const newState = !currentState;
                    control.setValue(newState);
                }
            });
        });

    }

    toggleRowExpansion(fieldKey: string) {
        this.rowExtensionOpen[fieldKey] = !this.rowExtensionOpen[fieldKey];
    }

    sort(entries: InputOutputConfigurationOptionsDropdownInterface[]) {
        entries.sort((a, b) => {
            // Move the 'Default' value to the top
            if (!a.id) return -1;
            if (!b.id) return 1;

            // Sort alphabetically by label for other values
            return a.label.localeCompare(b.label);
        });
    }

    onContextMenuField(event: MouseEvent, rowData: any, index: number) {
        this.contextMenuSelectedRow = rowData;
        this.fieldsContextMenuItems = this.getFieldContextMenu(rowData, index);
    }

    movePositionField(field: FormGroup, position: 'top' | 'bottom'): void {
        const widgetFieldArray = this.widgetField;
        const priorityControl = field.get('uiPriority');

        if (!priorityControl) return;

        const boundaryIndex = position === 'top' ? 0 : widgetFieldArray.length - 1;
        const boundaryControl = widgetFieldArray.at(boundaryIndex);
        const boundaryPriority = boundaryControl?.get('uiPriority')?.value;

        if (boundaryPriority === undefined) return;

        // Adjust priority
        const newPriority = position === 'top' ? boundaryPriority - 1 : boundaryPriority + 1;
        priorityControl.setValue(newPriority);

        // Sort by updated priority
        const sortedControls = [...widgetFieldArray.controls].sort((a, b) => {
            return (a.get('uiPriority')?.value ?? 0) - (b.get('uiPriority')?.value ?? 0);
        });

        // Rebuild the FormArray
        widgetFieldArray.clear();
        sortedControls.forEach(control => widgetFieldArray.push(control));

        this.toggleHiddenFields();
    }

    changeAttributePriority(): void {
        const fullList = [...this.widgetField.controls];
        const visibleSet = new Set(this.widgetUiFields);

        // Sort only the visible subset by current DOM order
        const reorderedVisible = [...this.widgetUiFields];

        // Rebuild full list: insert reordered visible in their places, preserve hidden order
        const reorderedFullList: FormGroup[] = [];

        let visibleIndex = 0;
        for (let i = 0; i < fullList.length; i++) {
            const isVisible = visibleSet.has(fullList[i]);
            reorderedFullList.push(isVisible ? reorderedVisible[visibleIndex++] : fullList[i]);
        }

        // Assign new uiPriority to ALL controls
        reorderedFullList.forEach((control, index) => {
            control.get('uiPriority')?.setValue(index + 1);
        });

        // Rebuild the form array in correct order
        this.widgetField.clear();
        reorderedFullList.forEach(ctrl => this.widgetField.push(ctrl));

        // Refresh table view
        this.toggleHiddenFields();
    }

    handleIconFieldExists(index: number, attribute: string): boolean {
        const attributeName = this.widgetField.controls[index].get(attribute).value;
        if (attributeName == 'icon' || attributeName == 'boolIcon' || attributeName == 'colorIcon') {
            return true;
        }
        return false;
    }

    handleBoolIconField(index: number, attribute: string): boolean {
        const attributeName = this.widgetField.controls[index].get(attribute).value;
        if (attributeName == 'boolIcon') {
            return true;
        }
        return false;
    }

    getFieldValue(index: number, attribute: string) {
        const attributeName = this.widgetField.controls[index].get(attribute).value;
        return attributeName;
    }

    onPasteIcon(event: ClipboardEvent, index: number, attribute: string) {

        event.preventDefault();

        const control = this.widgetField.controls[index].get(attribute);

        // Get the pasted text from the clipboard
        const pastedText = event.clipboardData?.getData('text/plain');

        if (pastedText) {
            // Define a regex pattern to match the font-awesome class
            const regexPattern = /class='([^']+)"/;

            // Use the regex pattern to search for a match in the pasted text
            const classMatch = pastedText.match(regexPattern);

            if (classMatch && classMatch.length > 1) {
                control.setValue(classMatch[1]);
            }
        }
    }

    handleFontAwesomeRedirect() {
        const url = 'https://fontawesome.com/search';
        window.open(url, '_blank');
    }

    handleFieldConfiguration() {
        const provider = this.widgetConfigService.getProvider(this.widgetType);

        const fields = provider.getFieldConfiguration(this.widgetType);

        fields.forEach(field => {
            this.visibleFields[field] = true; // You can set any default value here
        });
    }

    getValueListLabel(key: number, entries: MvsFormValueListEntryDto[]) {
        return entries.find(entry => entry.key == key).label;
    }

    handleFieldFilterMode() {
        this.showAllFields = !this.showAllFields;
        this.toggleHiddenFields();
    }

    handleReorderFilterMode() {
        this.showReorderFields = !this.showReorderFields;
        this.toggleHiddenFields();
    }

    handleNullFilterMode() {
        this.showNullFields = !this.showNullFields;
        this.toggleHiddenFields();
    }

    toggleHiddenFields(): void {
        const allFields = [...this.widgetField.controls];

        // Always sort base list
        let rows = allFields.sort(
            (a, b) => (a.get('uiPriority')?.value ?? 0) - (b.get('uiPriority')?.value ?? 0)
        );

        //Eye Filter (same as toggleHiddenFields)
        if (!this.showAllFields) {
            rows = rows.filter(field => {
                const hidden = field.get('uiHidden')?.value;
                return this.modeHideFields ? !hidden : hidden;
            });
        }

        //fa-light Filter Logic
        if (!this.showReorderFields) {
            rows = rows.filter(field => {
                const hidden = field.get('uiShowLabel')?.value;
                return this.modeHideFields ? !hidden : hidden;
            });
        }

        //fa-circle Null Filter Logic
        if (!this.showNullFields) {
            rows = rows.filter(field => {
                const hidden = field.get('uiHideNull')?.value;
                return this.modeHideFields ? !hidden : hidden;
            });
        }

        // Apply final filtered rows
        // this.widgetUiFields = rows;

        this.widgetUiFieldsAll = rows;
        this.widgetUiFields = this.widgetUiFieldsAll.slice(0, this.currentLimit);
    }

    private onUiOutputFieldChange(formGroup: FormGroup, fieldId: string): void {

        // get output field
        const outputField = this.formFieldService.getOutput(fieldId);

        // check if output field has special config component
        if (outputField && outputField.configComponent) {

            formGroup.get('uiOutputConfig').setValue({
                component: outputField.configComponent,
            });

            // Ensure uiConfigData FormGroup exists
            if (!formGroup.get('uiConfigData')) {
                formGroup.addControl('uiConfigData', new FormGroup({}));
            }
        } else {
            formGroup.get('uiOutputConfig').setValue(null);
            formGroup.removeControl('uiConfigData'); // Optionally remove uiConfigData
        }
    }

    private onUiInputFieldChange(formGroup: FormGroup, fieldId: string): void {

        // get output field
        const inputField = this.formFieldService.getInput(fieldId);

        // check if output field has special config component
        if (inputField && inputField.configComponent) {

            formGroup.get('uiInputConfig').setValue({
                component: inputField.configComponent,
            });

            // Ensure uiConfigData FormGroup exists
            if (!formGroup.get('uiConfigData')) {
                formGroup.addControl('uiConfigData', new FormGroup({}));
            }
        } else {
            formGroup.get('uiInputConfig').setValue(null);
            formGroup.removeControl('uiConfigData'); // Optionally remove uiConfigData
        }
    }

    handleDeleteField(widgetUiField: FormGroup): void {

        const widgetFieldArray = this.formGroup.get('widgetField') as FormArray;
        const index = widgetFieldArray.controls.indexOf(widgetUiField);

        if (index !== -1) {
            widgetFieldArray.removeAt(index);
            this.widgetUiFields = widgetFieldArray.controls;
        }
    }

    handleShowFilterInput() {
        this.showFilterInput = !this.showFilterInput;
    }

    handleFilterField(value: string) {
        const query = value?.toLowerCase();
        this.widgetUiFields = this.widgetField.controls.filter(fg => {
            let label;
            if (this.fieldNameRegularView) {
                label = fg.get('uiFieldLabel')?.value?.toLowerCase() ?? '';
            } else {
                label = fg.get('field')?.value?.toLowerCase() ?? '';
            }
            return label.includes(query);
        });
    }

    async showMore() {
        if (this.fieldsLoadingBusy) return;

        this.fieldsLoadingBusy = true;
        this.batching = true;

        // UI should repaint NOW (button disabled + spinner visible)
        // this.cd.markForCheck();
        // this.cd.detectChanges();

        // Defer heavy work to next frame
        await new Promise(resolve => setTimeout(resolve, 200));

        await this.loadBatchAsync();

        this.batching = false;
        this.fieldsLoadingBusy = false;

        this.refreshScrollableBody();
        // this.cd.detectChanges();
    }

    private async loadBatchAsync() {
        const target = this.currentLimit + this.pageSize;
        const nextLimit = Math.min(target, this.widgetUiFieldsAll.length);
        const BATCH = 20;

        while (this.currentLimit < nextLimit) {
            this.currentLimit = Math.min(this.currentLimit + BATCH, nextLimit);
            this.widgetUiFields = this.widgetUiFieldsAll.slice(0, this.currentLimit);

            // this.cd.detectChanges();

            // Yield to browser (allow UI to paint)
            await new Promise(resolve => setTimeout(resolve, 0));
        }
    }

    private refreshScrollableBody() {
        requestAnimationFrame(() => {
            const table = document.querySelector('.p-datatable-scrollable-body');
            if (table) table.scrollTop = table.scrollTop + 0.1;
        });
    }

    filterBySpecialType() {
        const all = this.widgetField.controls as FormGroup[];

        const visible: FormGroup[] = [];

        for (const fg of all) {
            // const type = fg.get('specialType')?.value;
            const type = fg?.value?.formField?.specialType;
            // ----------------------------------------------------------
            // CASE 1: Default fields = specialType is undefined or null
            // ----------------------------------------------------------
            if (type === null || type === undefined) {
                visible.push(fg);
                continue;
            }

            // ----------------------------------------------------------
            // CASE 2: Audit fields (enum = 0)
            // ----------------------------------------------------------
            if (type === FormFieldSpecialType.AUDIT && this.showAuditFields) {
                visible.push(fg);
                continue;
            }

            // ----------------------------------------------------------
            // CASE 3: Foreign ID fields (enum = 1)
            // ----------------------------------------------------------
            if (type === FormFieldSpecialType.FOREIGN_KEY_ID && this.showForeignIdFields) {
                visible.push(fg);
                continue;
            }
        }

        // Update UI rows safely without touching FormArray
        this.widgetUiFieldsAll = visible;
        this.widgetUiFields = visible.slice(0, this.currentLimit);
    }

    onToggleAuditFields(event: any) {
        this.showAuditFields = event.checked;
        this.filterBySpecialType();
    }

    onToggleForeignIdFields(event: any) {
        this.showForeignIdFields = event.checked;
        this.filterBySpecialType();
    }

}
